module.exports = __webpack_public_path__ + "img/diente.54cc714a.svg";